import SFXButtonComponent from "../../SFXButtonComponent";
import React, {Fragment} from "react";
import DigiPayPaymentService from "../../../services/Transaction/DigiPayPaymentService";
import ToastHelper from "../../../utils/ToastHelper";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TransactionService from "../../../services/Transaction/TransactionService";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import AuthorisationService from "../../../services/AuthorisationService";
import StepQuestion from "../../Step/StepQuestion";
import SFXRoundedButton from "../../SFXRoundedButton";

const views = {
    INITIAL: 'INITIAL',
    HAS_OPEN_AUTHORISATION: 'HAS_OPEN_AUTHORISATION',
    PAYMENT_SPLURB: 'PAYMENT_SPLURB',
    PAYMENT_OPTIONS: 'PAYMENT_OPTIONS',
    IFRAME: 'IFRAME'
}
export default class DigiPayPayNowButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            transactionId: props.transactionId,
            view: views.INITIAL,
            iFrameLoading: true
        }
    }

    componentDidMount() {
        TransactionService.retrieveTransactionByTransactionId(this.props.transactionId).then(
            transaction => {
                if (!transaction.transactionId) {
                    ToastHelper.formatError(transaction);
                    return;
                }
                this.setState({
                    transaction: transaction
                })
            }
        );
    }


    initiatePayment() {
        this.setState({
            isLoading: true
        }, () => {
            AuthorisationService.retrieveAuthorisationForTransactionIdAndPaymentReference(this.state.transactionId, this.state.transaction.paymentReference)
                .then(
                    (response) => {
                        if (response["has-authorisation"]) {
                            this.setState({
                                openAuth: response.authorisation,
                                isAuthOpen: true,
                                isLoading: false,
                                view: views.INITIAL
                            });
                            ToastHelper.warning('It seems someone is already trying to pay for this transaction. ' +
                                'Please wait 5 minutes and try again.')
                            return;
                        }

                        DigiPayPaymentService.initiatePayment(this.props.transactionId).then(
                            response => {
                                if (!(response.responseCode && response.responseCode === 'SUCCESS')) {
                                    ToastHelper.formatError(response);
                                    return;
                                }
                                if (response.webPaymentLinks.length === 0) {
                                    ToastHelper.error('Failed to load payment options');
                                    return;
                                }
                                this.setState({
                                    initiatePaymentResponse: response,
                                    view: views.PAYMENT_SPLURB
                                });
                            }
                        )
                    },
                    (error) => {
                        ToastHelper.formatError(error);
                    }
                );
        })

    }

    closeModal() {
        this.setState({
            view: views.INITIAL
        })
    }

    render() {
        return <Fragment>
            {this.renderButton()}
            {this.renderBody()}
        </Fragment>

    }

    renderBody() {
        switch (this.state.view) {
            case views.INITIAL : {
                return;
            }

            case views.HAS_OPEN_AUTHORISATION: {
                return this.renderHasOpenAuthorisation()
            }

            case views.PAYMENT_SPLURB: {
                return this.renderPaymentSplurb();
            }

            case views.PAYMENT_OPTIONS: {
                return this.renderPaymentOptions();
            }

            case views.IFRAME: {
                return this.renderIFrame();
            }
            default: {
                return <Fragment>Something went wrong</Fragment>
            }
        }
    }

    renderButton() {
        return <SFXRoundedButton
                value="Pay via EFT"
                onClick={this.initiatePayment.bind(this)}
        />
    }

    renderPaymentSplurb() {
        return <Fragment>
            <Modal toggle={this.closeModal.bind(this)} isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader>
                    You are about to make an EFT payment for your order on Ria Money Transfer
                    Please note the following:
                </ModalHeader>
                <ModalBody>
                    <p>
                        1. You are about to access your <span style={{fontWeight: 'bold'}}> OWN</span> banking account
                        in order for you to pay for your order that you had made with Ria Money Transfer
                    </p>
                    <p>
                        2. Please ensure that you do <span style={{fontWeight: 'bold'}}>NOT</span> share your banking
                        login details with anyone
                    </p>
                    <p>
                        3. Ria Money Transfers does <span style={{fontWeight: 'bold'}}>NOT</span> have access to
                        your banking details
                    </p>
                    <p>
                        4. Ria Money Transfers does <span style={{fontWeight: 'bold'}}>NOT</span> have access to
                        your banking login or pin numbers
                    </p>
                    <p>
                        5. If you encounter any problems with accessing your banking details, please directly contact
                        your bank
                    </p>
                    <p>
                        6. If you are suspicious of anyone other than you in accessing your bank account, please
                        directly contact your bank
                    </p>
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({view: views.INITIAL})
                        }
                    }>
                        Cancel
                    </SFXButtonComponent>
                    <SFXButtonComponent color="primary" onClick={
                        () => {
                            if (this.state.initiatePaymentResponse.webPaymentLinks.length === 1) {
                                this.setState({
                                    iframeUrl: this.state.initiatePaymentResponse.webPaymentLinks[0].paymentUrl,
                                    view: views.IFRAME
                                });
                            } else {
                                this.setState({
                                    view: views.PAYMENT_OPTIONS
                                });
                            }
                        }
                    }>
                        Continue
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderPaymentOptions() {
        return <Fragment>
            <Modal toggle={this.closeModal.bind(this)} isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader>
                    How would you like to pay for your transaction?
                </ModalHeader>
                <ModalBody>
                    Total cost of your transaction : R {this.state.transaction.total}<br/>
                    {
                        this.state.initiatePaymentResponse.webPaymentLinks.map((link, index) => {
                            return <SFXButtonComponent
                                key={index}
                                onClick={() => this.setState({
                                    iframeUrl: link.paymentUrl,
                                    view: views.IFRAME
                                })}
                                color={'primary'}
                            >{link.paymentMethodName}</SFXButtonComponent>
                        })
                    }
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({view: views.INITIAL})
                        }
                    }>
                        Cancel
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderIFrame() {
        return <Fragment>
            <Modal toggle={this.closeModal.bind(this)} isOpen={true} className={'modal-primary modal-lg'}>
                <ModalBody>
                    <iframe
                        id={'sfx-digipay-iframe'}
                        style={{
                            height: '100%',
                            width: '100%',
                            overflow: 'scroll',
                            minHeight: '600px',
                        }}
                        src={this.state.iframeUrl}
                        title={'PAY NOW'}
                        allow={'allow-same-origin'}
                        hidden={this.state.iFrameLoading}
                        onLoad={() => {
                            window.addEventListener('message', event => {
                                if (event.data === 'onLoad') {
                                    this.setState({
                                        iFrameLoading: false
                                    })
                                }
                                if (event.data === 'onClose') {
                                    this.closeModal()
                                }
                            })
                        }}
                    />
                    {this.state.iFrameLoading && <SFXLoadingComponent/>}
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderHasOpenAuthorisation() {
        return <Fragment>
            <Modal toggle={this.closeModal.bind(this)} isOpen={true} className={'modal-primary modal-lg'}>
                <ModalBody>
                    <StepQuestion>
                        It seems someone is already trying to pay for this transaction. <br/>
                        Please wait 5 minutes and try again.
                    </StepQuestion>
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({view: views.INITIAL})
                        }
                    }>
                        Okay
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>;
    }
}